import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    session: {
        settings: {},
        authorizations: {},
        account: {},
        forms: {},
    },
}

export const cacheSlice = createSlice({
    name: 'cache',
    initialState,
    reducers: {
        createCache: (state, action) => {
            if (action?.payload) {
                state['session'] = {
                    ...action.payload,
                }
            }
        },
        updateCache: (state, action) => {
            if (action?.payload) {
                state['session'] = {
                    ...action.payload,
                }
            }
        },
        deleteCache: (state) => {
            state['session'] = {}
        },
    },
})

export const selectCache = (state) => state.cache
export const { createCache, updateCache, deleteCache } = cacheSlice.actions
export default cacheSlice.reducer
